import useAuthStore from '~/store/auth'
import type { PERMISSIONS } from '~/types/permissions'

export const usePermissionCheck = (enabled: boolean = true) => {
  const { data: user } = useCurrentUser(enabled)

  const { isSuperAdmin } = storeToRefs(useAuthStore())

  const check = (permission: PERMISSIONS[], disableRolePrivileges: boolean = false) => {
    if (!user.value) {
      return false
    }

    // TODO: check this point with BE team
    if (isSuperAdmin.value && !disableRolePrivileges) {
      return true
    }

    return user.value.permissions?.some(userPermission => permission.includes(userPermission.name))
  }

  return {
    check,
  }
}
